import request from '@/utils/request'

/**
 * 工作台-车辆
 */

export function getBasicStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/statics/basic',
    method: 'POST',
    data,
  })
}

/**
 * 工作台-线索
 */
export function getClueStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/statics/clue',
    method: 'POST',
    data,
  })
}

/**
 * 工作台-经营风险
 */
export function getRiskStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/statics/manage',
    method: 'POST',
    data,
  })
}


/**
 * 工作台-联动网约统计
*/
export function getLinkageStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/statics/linkage',
    method: 'POST',
    data,
  })
}

/**
 * 代扣统计接口
 */

export function getWithholdStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/statics/withhold',
    method: 'POST',
    data,
  })
}

/**
 * 网约钱包支付开通中统计接口
 */
export function getWithholdOpeningStatics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/statics',
    method: 'POST',
    data,
  })
}

/**
 * 网约钱包支付开通中列表接口
 */
export function getWithholdOpeningList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/openingList',
    method: 'POST',
    data,
  })
}

/**
 * 开通网约钱包支付
*/
export function createWithholdAccount(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/account/apply/submit',
    method: 'POST',
    data,
  })
}

/**
 * 网约代扣开通申请记录详情
*/
export function getWithholdDetail(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/account/apply/detail',
    method: 'POST',
    data,
  })
}

/**
 * 工作台-开通支付宝支付校验接口
*/
export function checkWithholdOpenStatus(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/alipay/withhold/openCheck',
    method: 'POST',
    data,
  })
}


/**
 * 工作台-功能开通状态
*/
export function getDashboardFeatureList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/workbench/feature/list',
    method: 'POST',
    data,
  })
}

/**
 * 工作台-sp共享数据到期check与提醒
 */

export function spDataShareExpireCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/workbench/spDataShareExpireCheck',
    method: 'POST',
    data,
  })
}
